import React from 'react';
import { history } from 'umi';
import { Form, Input, Button, notification, Avatar } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { login } from '@/api/examinationApi';
// import { Base64 } from 'js-base64';
const { Base64 } = require("js-base64");
import { setToken, setUserName } from '@/utils/Auth';
import loginStyle from './index.css';
import PropTypes from "prop-types";
import type { Location } from "history";

interface Props { location: Location & { query: { [key: string]: string } } }
interface State {
    userName: string;
    redirectUrl: string;
    userPwd: string;
}
/** 登录类 */
class LoginForm extends React.Component<Props, State> {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };
    /** 构造函数 */
    constructor(props) {
        super(props);
        this.state = {
            userName: '',
            userPwd: '',
            redirectUrl: '',
        };
    }

    /** 生命周期 */
    componentDidMount() {
        console.log(this.props.location.search);

        const query = this.props.location.query;
        this.setState({ redirectUrl: query.redirectUrl || "/create_exam_lark" });
    }

    /** 完成 */
    onFinish(value: any) {
        this.setState({
            userName: value.username,
            userPwd: encodeURIComponent(Base64.encode(value.password))
        });
        login(this.state.userName, this.state.userPwd).then(({ data }) => {
            if (data.return_msg === 'success') {
                const { token, name } = data.data;
                setToken(token);
                setUserName(name);
                history.push(this.state.redirectUrl);
                notification["success"]({
                    message: "登录成功",
                    description: ''
                });
            } else {
                notification["error"]({
                    message: "登录失败",
                    description: '检查账户名或密码是否正确'
                });
            }
        });
    }

    /** 渲染函数 */
    render() {
        return (
            <div style={{height: '100vh', width: '100vw', backgroundImage: 'url(assets/img/hero/h1_hero.png)', backgroundSize: 'cover'}}>
                <div className={loginStyle.login_conatiner}>
                    <Avatar size="large" className={loginStyle.avatar}>子衿</Avatar>
                    <Form
                        name="normal_login"
                        className="login-form"
                        initialValues={{ remember: true }}
                        onFinish={this.onFinish.bind(this)}
                    >
                        <Form.Item
                            name="username"
                            rules={[{ required: true, message: 'Please input your Username!' }]}
                        >
                            <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            rules={[{ required: true, message: 'Please input your Password!' }]}
                        >
                            <Input
                                prefix={<LockOutlined className="site-form-item-icon" />}
                                type="password"
                                placeholder="Password"
                            />
                        </Form.Item>
                        <Form.Item>
                            {/* <Form.Item name="remember" valuePropName="false" noStyle>
                                <Checkbox>记住我</Checkbox>
                            </Form.Item> */}
                            {/* <Link to="/examine" className={loginStyle.examine}>&gt;&gt;&gt;提交答卷</Link> */}
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" style={{ width: "100%", height: "2.5rem" }} className="login-form-button">
                                登录
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>

        );
    }
}

export default LoginForm;
